import { render, staticRenderFns } from "./NewCatalog.vue?vue&type=template&id=aaaf8492&scoped=true&"
import script from "./NewCatalog.vue?vue&type=script&lang=js&"
export * from "./NewCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaf8492",
  null
  
)

export default component.exports